var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('img',{attrs:{"src":_vm.iconImg}}),_vm._v("\n    "+_vm._s(_vm.title)+"\n    "),_c('img',{attrs:{"src":_vm.iconcImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }